import React, { useEffect } from "react";
import { ROUTES } from "../../../../consts";
import { MinusIcon, PlusIcon } from "@heroicons/react/solid";
import { useTrackContext } from "../../../../hooks/useTrackContext";
import NewsletterPopup from "../../../NewsletterPopup";
import ProgressBar from "../../../ProgressiveBar";
import MiniCart from "../../../Cart/MiniCart";
import { SHOPIFY_STOREFRONT_GRAPHQL_API, SHOPIFY_STOREFRONT_TOKEN } from "../../../../config";
import { GET_METAOBJECT_BY_HANDLE } from "../../../../graphqlQueries";
import BottomSummary from "../../../BottomSummary";

const MiniSelectSeatsRaces: React.FC = () => {
  const { dispatch, miniTrackSection, productRenderedLocation, metaObjectMiniTrackSectionConfig, appHostedAt } = useTrackContext();
  const { racesSeats } = miniTrackSection;
  const { seatsAndRacesSection } = metaObjectMiniTrackSectionConfig;

  const handleRacePlus = () => {
    if (miniTrackSection.racesSeats.numberOfRaces < seatsAndRacesSection.maxRaceQuantity) {
      dispatch({
        type: "SET_RACES_SEATS_MINI_TRACK",
        payload: {
          selectedTrack: "MINI_TRACK",
          racesSeats: {
            ...miniTrackSection.racesSeats,
            numberOfRaces: miniTrackSection.racesSeats.numberOfRaces + 1,
          },
        },
      });
    }
  };

  const handleRaceMinus = () => {
    dispatch({
      type: "SET_RACES_SEATS_MINI_TRACK",
      payload: {
        selectedTrack: "MINI_TRACK",
        racesSeats: {
          ...miniTrackSection.racesSeats,
          numberOfRaces: Math.max(1, miniTrackSection.racesSeats.numberOfRaces - 1),
        },
      },
    });
  };

  const handleSeatPlus = () => {
    if (miniTrackSection.racesSeats.numberOfSeats < seatsAndRacesSection.maxSeatsQuantity) {
      dispatch({
        type: "SET_RACES_SEATS_MINI_TRACK",
        payload: {
          selectedTrack: "MINI_TRACK",
          racesSeats: {
            ...miniTrackSection.racesSeats,
            numberOfSeats: miniTrackSection.racesSeats.numberOfSeats + 1,
          },
        },
      });
    }
  };

  const handleSeatMinus = () => {
    dispatch({
      type: "SET_RACES_SEATS_MINI_TRACK",
      payload: {
        selectedTrack: "MINI_TRACK",
        racesSeats: {
          ...miniTrackSection.racesSeats,
          numberOfSeats: Math.max(1, miniTrackSection.racesSeats.numberOfSeats - 1),
        },
      },
    });
  };

  // Get data from metaobjects
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [termsResponse, imageResponse] = await Promise.all([
          fetch(SHOPIFY_STOREFRONT_GRAPHQL_API, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_TOKEN,
            },
            body: JSON.stringify({
              query: GET_METAOBJECT_BY_HANDLE,
              variables: {
                handle: "terms_and_conditions_mini_track",
                type: "information_react_component",
              },
            }),
          }),
          fetch(SHOPIFY_STOREFRONT_GRAPHQL_API, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_TOKEN,
            },
            body: JSON.stringify({
              query: GET_METAOBJECT_BY_HANDLE,
              variables: {
                handle: "upsell_images_react_component_mini_track",
                type: "upsell_images_react_component",
              },
            }),
          }),
        ]);

        if (!termsResponse.ok) {
          throw new Error("Failed to fetch terms and conditions data");
        }

        if (!imageResponse.ok) {
          throw new Error("Failed to fetch image data");
        }

        const [termsData, imageData] = await Promise.all([termsResponse.json(), imageResponse.json()]);

        const termsAndConditionsContent = termsData.data.metaobject.fields[0].value;

        const imageFields = imageData.data.metaobject.fields;
        const miniTrackUpsellImageIds = imageFields.map((item: any) => item.value);

        dispatch({
          type: "SET_TERMS_AND_CONDITIONS_CONTENT",
          payload: { termsAndConditionsContent },
        });

        dispatch({
          type: "SET_MINI_TRACK_UPSELL_IMAGE_ID_FROM_METAOBJECT",
          payload: { miniTrackUpsellImageIds },
        });
      } catch (error: any) {
        console.error("Error fetching data:", error.message);
      }
    };

    fetchData();
  }, [dispatch]);

  return (
    <>
      <ProgressBar maxValue={100} currentValue={45} />
      {productRenderedLocation === "external" && <MiniCart />}

      {/* <span className="tw-block tw-text-[18px] lg:tw-text-[24px] tw-text-[#19E6FE] tw-font-[700] tw-mt-[30px] tw-text-center">Mini Track</span> */}
      {/* <div className="tw-text-white tw-text-center tw-text-[24px] tw-font-extrabold">
        {seatsAndRacesSection.mainTitle ? seatsAndRacesSection.mainTitle : "Select your Seats and Races"}
      </div> */}

      <div className="tw-container tw-mx-auto">
        <div
          className={`tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 ${
            appHostedAt && appHostedAt === "bosshunting" ? "tw-gap-[30px]" : "tw-gap-[30px] lg:tw-gap-[160px]"
          } tw-my-[30px] lg:tw-my-[160px]`}
        >
          <div className="tw-max-w-[455px] tw-w-full tw-mx-auto lg:tw-mx-0 lg:tw-ml-auto">
            <div className="tw-text-white tw-text-center">
              <span className="tw-text-[20px] lg:tw-text-[25px] tw-font-[700]">{seatsAndRacesSection.seatsTitle ? seatsAndRacesSection.seatsTitle : "Seat(s)"}</span>
              <div className="tw-flex tw-justify-center tw-mt-[20px]">
                <div className="tw-flex tw-items-center tw-gap-[30px]">
                  <span
                    className={`tw-rounded-full tw-p-[5px] hover:tw-cursor-pointer ${racesSeats.numberOfSeats <= 1 ? "tw-bg-[#555758]" : "tw-bg-[#9D62FE]"}`}
                    onClick={handleSeatMinus}
                  >
                    <MinusIcon className="tw-w-[35px] tw-h-[35px]" />
                  </span>
                  <span className="tw-text-[30px] tw-font-bold tw-border-[2px] tw-rounded-[15px] tw-border-[#EBECEF] tw-bg-[#393B41] tw-py-[4px] tw-px-[60px]">
                    {racesSeats.numberOfSeats}
                  </span>
                  <span
                    className={`tw-rounded-full tw-p-[5px] ${
                      racesSeats.numberOfSeats === seatsAndRacesSection.maxSeatsQuantity ? "tw-bg-[#555758] tw-cursor-not-allowed" : "tw-bg-[#9D62FE] hover:tw-cursor-pointer"
                    }`}
                    onClick={handleSeatPlus}
                  >
                    <PlusIcon className="tw-w-[35px] tw-h-[35px]" />
                  </span>
                </div>
              </div>
              <p
                className={`tw-text-white tw-text-[18px] tw-font-[400] tw-text-center ${
                  appHostedAt && appHostedAt === "bosshunting" ? "tw-p-[10px] lg:tw-px-[20px]" : "tw-max-w-[375px] tw-w-full"
                } tw-mx-auto tw-mt-[24px] lg:tw-mt-[30px]`}
                style={appHostedAt && appHostedAt === "bosshunting" ? { textDecoration: "none", width: "unset", height: "unset", margin: 0, maxWidth: "unset" } : {}}
              >
                {seatsAndRacesSection.seatsDescription ? seatsAndRacesSection.seatsDescription : "Increase seats to see what races can fit your group size"}
              </p>
            </div>
          </div>
          <div className="tw-max-w-[455px] tw-w-full tw-mx-auto lg:tw-mx-0 lg:tw-mr-auto">
            <div className="tw-text-white tw-text-center">
              <span className="tw-text-[20px] lg:tw-text-[25px] tw-font-[700]">{seatsAndRacesSection.raceTitle ? seatsAndRacesSection.raceTitle : "Race(s)"}</span>
              <div className="tw-flex tw-justify-center tw-mt-[20px]">
                <div className="tw-flex tw-items-center tw-gap-[30px]">
                  <span
                    className={`tw-rounded-full tw-p-[5px] hover:tw-cursor-pointer ${racesSeats.numberOfRaces <= 1 ? "tw-bg-[#555758]" : "tw-bg-[#9D62FE]"}`}
                    onClick={handleRaceMinus}
                  >
                    <MinusIcon className="tw-w-[35px] tw-h-[35px]" />
                  </span>
                  <span className="tw-text-[30px] tw-font-bold tw-border-[2px] tw-rounded-[15px] tw-border-[#EBECEF] tw-bg-[#393B41] tw-py-[4px] tw-px-[60px]">
                    {racesSeats.numberOfRaces}
                  </span>
                  <span
                    className={`tw-rounded-full tw-p-[5px] hover:tw-cursor-pointer ${
                      racesSeats.numberOfRaces === seatsAndRacesSection.maxRaceQuantity ? "tw-bg-[#555758]" : "tw-bg-[#9D62FE]"
                    }`}
                    onClick={handleRacePlus}
                  >
                    <PlusIcon className="tw-w-[35px] tw-h-[35px]" />
                  </span>
                </div>
              </div>
              <p
                className={`tw-text-white tw-text-[18px] tw-font-[400] tw-text-center ${
                  appHostedAt && appHostedAt === "bosshunting" ? "tw-p-[10px] lg:tw-px-[20px]" : "tw-max-w-[375px] tw-w-full"
                } tw-mx-auto tw-mt-[24px] lg:tw-mt-[30px]`}
                style={appHostedAt && appHostedAt === "bosshunting" ? { textDecoration: "none", width: "unset", height: "unset", margin: 0, maxWidth: "unset" } : {}}
              >
                {seatsAndRacesSection.raceDescription ? seatsAndRacesSection.raceDescription : "We recommend 2-3 races per person with a 15 minute break in between"}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="tw-w-full lg:tw-h-[126px] tw-p-[30px] tw-mt-[40px] lg:tw-mt-0">
        <div className="tw-flex tw-justify-center tw-items-center">
          <div
            className={`${
              productRenderedLocation === "external" ? "tw-container tw-mx-auto" : "container mx-auto"
            } tw-relative tw-flex tw-justify-end tw-items-center tw-gap-[15px] lg:tw-block`}
          >
            <NewsletterPopup />
          </div>
        </div>
      </div>

      <BottomSummary
        previousInfo={{ pageName: "Game Selection", pagePath: "/" }}
        nextInfo={{ pageName: "Continue", pagePath: "/" + ROUTES.MINI_TRACK.DATE_TIME, isActive: true }}
      />
    </>
  );
};

export default MiniSelectSeatsRaces;
